/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_ReplacementInputs */



/**
* | output |
* | --- |
* | "Automatic Replacement & Shortforms" |
*
* @param {Signup_Compare_ReplacementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_replacement = /** @type {((inputs?: Signup_Compare_ReplacementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_ReplacementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Automatic Replacement & Shortforms")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatic Replacement & Shortforms")
	if (locale === "it") return /** @type {LocalizedString} */ ("Automatic Replacement & Shortforms")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Automatic Replacement & Shortforms")
	if (locale === "es") return /** @type {LocalizedString} */ ("Automatic Replacement & Shortforms")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Automatic Replacement & Shortforms")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Automatic Replacement & Shortforms")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Automatic Replacement & Shortforms")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Automatic Replacement & Shortforms")
	return /** @type {LocalizedString} */ ("Automatic Replacement & Shortforms")
});